import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ListTracingConstants, LIST_ACTIONS } from '@usf/ngrx-list';
import { ProductSummaryActions } from '@usf/ngrx-product';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ListProductEffects {
  failedToLoadProductsOnList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductSummaryActions.FetchProductSummariesFail),
      filter(() => this.isOnAList(this.router.url)),
      map(() =>
        LIST_ACTIONS.productsFailedToLoad({
          tracking: {
            tracing: {
              data: {
                traceContext: 'productsFailedToLoadOnList',
                isStartOfTrace: true,
                isEndOfTrace: true,
              },
            },
          },
        }),
      ),
    ),
  );

  isOnAList(url: string): boolean {
    return (
      (url.includes('lists') && url.includes('detail')) ||
      url.includes('recentlyPurchased') ||
      url.includes('masterList')
    );
  }

  constructor(private actions$: Actions, private router: Router) {}
}
